import { FieldShell } from './FieldShell';
import { useFieldName, useDomFieldId } from './_useFieldName';
import { FIELD_AUTOCOMPLETE_OFF, FIELD_NO_AUTOFILL, onNoAutofillProps, onResolveFriendlyPlaceholder } from './_fieldDefaults';

const BLOCK = 'LStudio__app_field';

/*
    🔥 TEXTAREA

    ⚠️ Sin resize por defecto: la manija de la esquina rompe el borde
       redondeado, se sale de la grilla y descuadra la fila entera.
       Si lo necesitás en algún caso puntual: resize="vertical".

    Con contador opcional si pasás maxLength.
*/

export const FieldTextarea = ({
    id, name, label, hint, error,
    value, onChange, placeholder,
    rows = 4, maxLength = null, autoComplete = null,
    resize = 'none',                        // none | vertical | horizontal | both
    isRequired = false, isDisabled = false, isReadOnly = false,
    noAutofill = true, onFocus = null, onBlur = null,
    span = 2, ...rest
}) => {

    const LENGTH = String(value ?? '').length;

    const GUARD = noAutofill ? onNoAutofillProps({ isReadOnly, isDisabled }) : {};

    const { domName, onChangeField, onBlurField } = useFieldName({ id, name, onChange, onBlur, isEnabled: noAutofill });

    const onHandleFocus = (event) => {
        GUARD.onFocus?.(event);
        onFocus?.(event);
    };

    const DOM_ID = useDomFieldId(id);
    const RESOLVED_PLACEHOLDER = onResolveFriendlyPlaceholder({ placeholder, label, type: 'text', multiline: true });

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span}
            isRequired={isRequired} isDisabled={isDisabled}
            hint={maxLength ? `${hint ? `${hint} · ` : ''}${LENGTH}/${maxLength}` : hint} >

            <textarea id={DOM_ID} data-field={name ?? id} name={domName} rows={rows}
                className={`${BLOCK}__input ${BLOCK}__input--textarea`}
                data-resize={resize}
                value={value ?? ''} onChange={onChangeField} onBlur={onBlurField}
                placeholder={RESOLVED_PLACEHOLDER} maxLength={maxLength ?? undefined}
                autoComplete={autoComplete ?? FIELD_AUTOCOMPLETE_OFF}
                required={isRequired} disabled={isDisabled}
                aria-invalid={!!error}
                {...FIELD_NO_AUTOFILL}
                {...GUARD}
                readOnly={isReadOnly || GUARD.readOnly}
                onFocus={onHandleFocus}
                {...rest} />

        </FieldShell>
    );
};
